import * as React from 'react';
import { Select as AntdSelect } from 'antd';
import type { SelectProps } from 'antd';
import './select.scss';

// تنها primitive سلکت پروژه. عمداً یک لایه‌ی نازک روی antd Select است تا هیچ
// قابلیتی (mode="multiple"، showSearch، allowClear، Select.Option و ...) از دست نرود
// و در عین حال همه‌ی دراپ‌داون‌های پنل یک ظاهر و یک رفتار داشته باشند.
// به‌جای `import { Select } from 'antd'` از این استفاده کنید.
type Props = SelectProps<any>;

const PmxSelect: React.FC<Props> = ({ className, popupClassName, ...rest }) => (
    <AntdSelect
        className={`pmx-select ${className ?? ''}`}
        popupClassName={`pmx-select-popup ${popupClassName ?? ''}`}
        // پاپ‌آور دقیقاً هم‌عرض خود سلکت باز می‌شود.
        popupMatchSelectWidth
        {...rest}
    />
);

// تا `<Select.Option>` در محل‌های استفاده‌ی موجود بدون تغییر کار کند.
export const Select = Object.assign(PmxSelect, {
    Option: AntdSelect.Option,
    OptGroup: AntdSelect.OptGroup,
});
